import React, { useState, useEffect } from 'react';
import { FiInfo, FiLayers, FiMaximize2, FiFilter } from 'react-icons/fi';
import { motion } from 'framer-motion';
import api from '../../utils/api';

const kecamatanData = [
  { id: 'aimere', name: 'Aimere', lx: 175, ly: 465, path: 'M150,450 L180,440 L210,430 L220,460 L195,475 L175,485 L150,470 Z', color: '#10b981' },
  { id: 'bajawa', name: 'Bajawa', lx: 235, ly: 445, path: 'M210,430 L240,420 L270,410 L285,430 L270,445 L245,455 L220,460 Z', color: '#32966c' },
  { id: 'bajawautara', name: 'Bajawa Utara', lx: 300, ly: 415, path: 'M270,410 L310,380 L330,400 L320,420 L285,430 Z', color: '#3b82f6' },
  { id: 'golewa', name: 'Golewa', lx: 255, ly: 485, path: 'M220,460 L245,455 L270,445 L290,480 L265,495 L240,500 Z', color: '#10b981' },
  { id: 'golewabarat', name: 'Golewa Barat', lx: 200, ly: 505, path: 'M175,485 L195,475 L220,460 L240,500 L215,515 L190,520 Z', color: '#32966c' },
  { id: 'golewaselatan', name: 'Golewa Selatan', lx: 275, ly: 525, path: 'M240,500 L265,495 L290,480 L315,515 L300,535 L260,540 Z', color: '#8b5cf6' },
  { id: 'inerie', name: 'Inerie', lx: 155, ly: 510, path: 'M130,480 L160,485 L175,485 L190,520 L160,525 L130,510 Z', color: '#e86f4c' },
  { id: 'jerebuu', name: 'Jerebuu', lx: 220, ly: 570, path: 'M190,520 L215,515 L240,500 L260,540 L280,580 L240,590 L210,570 Z', color: '#d4a012' },
  { id: 'riung', name: 'Riung', lx: 340, ly: 330, path: 'M280,300 L320,290 L360,280 L390,320 L380,355 L340,370 L310,380 L290,340 Z', color: '#3b82f6' },
  { id: 'riungbarat', name: 'Riung Barat', lx: 270, ly: 360, path: 'M240,330 L270,310 L280,300 L290,340 L310,380 L280,410 L250,380 Z', color: '#10b981' },
  { id: 'soa', name: 'Soa', lx: 330, ly: 425, path: 'M310,380 L340,370 L380,400 L360,440 L320,455 L285,430 L310,400 Z', color: '#32966c' },
  { id: 'wolomeze', name: 'Wolomeze', lx: 410, ly: 430, path: 'M380,400 L410,390 L440,380 L450,420 L420,445 L380,455 L360,440 Z', color: '#e86f4c' }
];

const PetaPage = () => {
    const [selectedKec, setSelectedKec] = useState(null);
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [metric, setMetric] = useState('avgNilai');

    useEffect(() => {
        const load = async () => {
            try {
                const res = await api.get('/datasets/kecamatan');
                setStats(res.data.data);
                if (res.data.data.length > 0) setSelectedKec(res.data.data[1]); // Default to Bajawa
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    const getKecStat = (name) => stats.find(s => s._id.toLowerCase() === name.toLowerCase());

    return (
        <div style={{ paddingTop: 80, minHeight: 'calc(100vh - 80px)', display: 'flex', flexDirection: 'column', background: 'var(--gray-50)' }}>
            {/* Toolbar */}
            <div className="container-wide" style={{ padding: '1rem 2rem', background: 'var(--card-bg)', borderBottom: '1px solid var(--gray-100)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <h2 style={{ fontSize: '1.25rem', marginBottom: '0.2rem' }}>Peta Digital Kabupaten Ngada</h2>
                    <p style={{ fontSize: '0.75rem', color: 'var(--gray-500)' }}>Visualisasi data geospasial real-time per kecamatan</p>
                </div>
                <div style={{ display: 'flex', gap: '1rem' }}>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                        <select className="form-select" value={metric} onChange={e => setMetric(e.target.value)} style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }}>
                            <option value="avgNilai">Rata-rata Capaian Sektoral</option>
                            <option value="totalData">Volume Dataset</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* Main Area */}
            <div className="peta-layout">
                {/* Sidebar */}
                <motion.div 
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="peta-sidebar"
                >
 Sarah: 2026-04-03 PS: Transitioned Peta sidebar to use the new responsive class system.
                    {selectedKec ? (
                        <div className="animate-in">
                            <span className="badge badge-primary">{selectedKec._id}</span>
                            <h3 style={{ marginTop: '0.5rem', marginBottom: '1.5rem' }}>Profil Kecamatan {selectedKec._id}</h3>
                            <div className="stats-grid" style={{ gridTemplateColumns: '1fr', gap: '1rem' }}>
                                <div className="card" style={{ padding: '1.25rem', background: 'var(--primary-600)', color: '#fff' }}>
                                    <div style={{ fontSize: '0.75rem', opacity: 0.8 }}>Volume Data</div>
                                    <div style={{ fontSize: '2rem', fontWeight: 700 }}>{getKecStat(selectedKec._id)?.totalData || 0}</div>
                                    <div style={{ fontSize: '0.7rem', marginTop: '0.5rem' }}>Dataset terpublikasi</div>
                                </div>
                                <div className="card" style={{ padding: '1.25rem' }}>
                                    <div style={{ color: 'var(--gray-500)', fontSize: '0.75rem' }}>Capaian Strategis</div>
                                    <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{getKecStat(selectedKec._id)?.avgNilai?.toFixed(1) || 0}%</div>
                                    <div style={{ fontSize: '0.7rem', color: 'var(--gray-400)', marginTop: '0.5rem' }}>Rerata Indikator Pembangunan</div>
                                </div>
                            </div>
                            <div style={{ marginTop: '2rem' }}>
                                <h4>💡 Wawasan Geospasial</h4>
                                <p style={{ fontSize: '0.85rem', color: 'var(--gray-500)', marginTop: '0.5rem', lineHeight: '1.5' }}>
                                    Kecamatan {selectedKec._id} menunjukkan stabilitas pada indikator pembangunan dasar. Diperlukan peningkatan pada sektor digitalisasi pelayanan publik.
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center', color: 'var(--gray-400)', marginTop: '4rem' }}>
                            <FiMaximize2 size={40} style={{ marginBottom: '1rem' }} />
                            <p>Pilih kecamatan pada peta untuk melihat detail</p>
                        </div>
                    )}
                </motion.div>

                {/* Map View */}
                <motion.div 
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8 }}
                    className="peta-map-view"
                >
                    <svg viewBox="100 250 400 350" style={{ width: '80%', height: '80%', filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.1))' }}>
                        {kecamatanData.map(kec => (
                            <motion.path
                                key={kec.id}
                                d={kec.path}
                                fill={selectedKec?._id === kec.name ? 'var(--primary-600)' : kec.color}
                                stroke="#fff"
                                strokeWidth="2"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                whileHover={{ scale: 1.02, filter: 'brightness(1.1) drop-shadow(0 0 8px rgba(0,0,0,0.2))' }}
                                style={{ cursor: 'pointer', transition: 'fill 0.3s' }}
                                onClick={() => setSelectedKec({ _id: kec.name })}
                            />
                        ))}
                        {/* Labels */}
                        {kecamatanData.map(kec => (
                            <text
                                key={`label-${kec.id}`}
                                x={kec.lx}
                                y={kec.ly}
                                style={{ fontSize: 9, fill: '#fff', pointerEvents: 'none', fontWeight: 600, textShadow: '0 1px 2px rgba(0,0,0,0.5)' }}
                            >
                                {kec.name}
                            </text>
                        ))}
                    </svg>

                    {/* Legend */}
                    <div style={{ position: 'absolute', bottom: 30, right: 30, background: 'rgba(255,255,255,0.9)', padding: '1rem', borderRadius: '12px', border: '1px solid var(--gray-100)', fontSize: '0.75rem' }}>
                        <div style={{ fontWeight: 700, marginBottom: '0.5rem' }}>Indikator Strategis</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><div style={{ width: 12, height: 12, background: '#10b981' }} /> Baik & Mantap</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><div style={{ width: 12, height: 12, background: '#3b82f6' }} /> Dalam Pemeliharaan</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><div style={{ width: 12, height: 12, background: '#d4a012' }} /> Butuh Perhatian</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><div style={{ width: 12, height: 12, background: '#e86f4c' }} /> Kritis</div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default PetaPage;
